<template>
  <a-drawer
    title="师傅派单"
    :width="720"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
    :destroyOnClose="true"
  >
    <div class="order-info-section">
      <div class="section-title">订单信息</div>
      <a-row :gutter="24">
        <a-col :span="12">
          <div class="info-item">
            <span class="info-label">订单编号：</span>
            <span class="info-value">{{ currentOrder.orderNo || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="info-item">
            <span class="info-label">客户姓名：</span>
            <span class="info-value">{{ currentOrder.receiverName || '-' }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <div class="info-item">
            <span class="info-label">客户地址：</span>
            <span class="info-value">{{ currentOrder.receiverDetailedAddress || '-' }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <div class="info-item">
            <span class="info-label">预约时间：</span>
            <span class="info-value">{{ currentOrder.receiverUpTime || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="info-item">
            <span class="info-label">联系电话：</span>
            <span class="info-value">{{ currentOrder.receiverMobile || '-' }}</span>
          </div>
        </a-col>
      </a-row>
    </div>

    <div class="master-selection-section">
      <div class="section-title">选择师傅</div>
      <a-card
        :bordered="false"
        class="master-card"
        :class="{ 'master-selected': selectedMaster.id }"
        @click="openMasterSelection"
      >
        <div class="master-card-content">
          <div class="master-avatar" v-if="selectedMaster.id">
            <a-avatar :size="40" :src="selectedMaster.avatar" style="background-color: #1890ff">
              {{ selectedMaster.name ? selectedMaster.name.charAt(0) : '师' }}
            </a-avatar>
          </div>
          <div class="master-info">
            <div class="master-name" v-if="selectedMaster.id">
              {{ selectedMaster.name }}
              <a-tag color="blue" v-if="selectedMaster.level">{{ selectedMaster.level }}</a-tag>
            </div>
            <div class="master-phone" v-if="selectedMaster.phone">{{ selectedMaster.phone }}</div>
            <div class="master-rating" v-if="selectedMaster.rating">
              <a-rate :value="selectedMaster.rating" disabled allow-half />
              <span class="rating-text">{{ selectedMaster.rating }}分</span>
            </div>
            <div class="select-placeholder" v-if="!selectedMaster.id">
              <a-icon type="user-add" />
              <span>点击选择师傅</span>
            </div>
          </div>
          <div class="master-actions">
            <a-button type="link" @click.stop="openMasterSelection">
              {{ selectedMaster.id ? '重新选择' : '选择师傅' }}
            </a-button>
          </div>
        </div>
      </a-card>
    </div>

    <div class="drawer-footer">
      <a-button @click="onClose" style="margin-right: 8px">取消</a-button>
      <a-button type="primary" @click="submitAssign" :loading="submitLoading" :disabled="!selectedMaster.id">
        确认派单
      </a-button>
    </div>

    <SelectMasterDrawer ref="selectMasterDrawer" @select="handleMasterSelect" />
  </a-drawer>
</template>

<script>
import SelectMasterDrawer from './SelectMasterDrawer'
import { putObj } from '@/api/repairModule/repairMaster'
export default {
  name: 'AssignMasterDrawer',
  components: { SelectMasterDrawer },
  data() {
    return {
      visible: false,
      submitLoading: false,
      currentOrder: {
        orderNo: '',
        receiverName: '',
        receiverDetailedAddress: '',
        receiverUpTime: '',
        receiverPhone: '',
      },
      selectedMaster: {},
    }
  },
  methods: {
    show(order) {
      this.visible = true
      this.currentOrder = { ...order }
      this.selectedMaster = {}
    },
    handleMasterSelect(master) {
      this.selectedMaster = { ...master }
    },
    onClose() {
      this.visible = false
      this.selectedMaster = {}
      this.currentOrder = {}
    },
    openMasterSelection() {
      this.$refs.selectMasterDrawer.show()
    },
    submitAssign() {
      if (!this.selectedMaster.id) {
        this.$message.warning('请选择师傅')
      }
      this.submitLoading = true
      const form = {
        id: this.currentOrder.id,
        orderId: this.currentOrder.id,

        userId: this.selectedMaster.id,
        userName: this.selectedMaster.name,
        userPhone: this.selectedMaster.phone,
      }
      putObj(form)
        .then((response) => {
          this.submitLoading = false
          this.visible = false
          this.$emit('success', {
            order: this.currentOrder,
            master: this.selectedMaster,
          })
          this.$message.success('派单成功')
        })
        .finally(() => {
          this.submitLoading = false
          this.showLoading = false
        })
    },
  },
}
</script>

<style scoped>
.order-info-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #262626;
  display: flex;
  align-items: center;
}

.section-title::before {
  content: '';
  width: 3px;
  height: 16px;
  background: #1890ff;
  margin-right: 8px;
  border-radius: 1px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.info-label {
  color: #666;
  min-width: 80px;
  font-size: 14px;
}

.info-value {
  color: #262626;
  font-weight: 500;
  flex: 1;
  word-break: break-all;
}

.master-selection-section {
  margin-bottom: 24px;
}

.master-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px dashed #d9d9d9;
}

.master-card:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}

.master-selected {
  border: 1px solid #1890ff;
  border-style: solid;
}

.master-card-content {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.master-avatar {
  margin-right: 16px;
}

.master-info {
  flex: 1;
}

.master-name {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.master-name .ant-tag {
  margin-left: 8px;
  font-size: 12px;
}

.master-phone {
  color: #666;
  font-size: 14px;
  margin-bottom: 4px;
}

.master-rating {
  display: flex;
  align-items: center;
}

.rating-text {
  margin-left: 8px;
  color: #fa8c16;
  font-size: 14px;
}

.select-placeholder {
  color: #bfbfbf;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.select-placeholder .anticon {
  margin-right: 8px;
  font-size: 16px;
}

.master-actions {
  margin-left: auto;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-row {
  margin-bottom: 8px;
}

.ant-row:last-child {
  margin-bottom: 0;
}
</style>
